// // src/App.jsx
// import React, { useEffect } from 'react';
// import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// import Login from './screen/AuthScreen/Login';
// import Register from './screen/AuthScreen/Register';
// import ForgotPassword from './screen/AuthScreen/ForgotPassword';
// import ResetPassword from './screen/AuthScreen/ResetPassword';
// import UserDetailsForm from './screen/UserDetailScreen/UserDetailsForm';
// import HomePage from './screen/dashboard/HomePage';
// import ProfilePage from './screen/dashboard/ProfilePage';
// import ChatPage from './screen/dashboard/ChatPage';

// import PublicRoute from './components/auth/PublicRoute';
// import ProtectedRoute from './components/auth/ProtectedRoute';

// import signalRService from './services/signalrService';
// import { useSignalRChat } from './store/api/chatApi';
// import { useSignalRNotifications } from './store/api/notificationApi';

// import FollowersPage from './components/FollowersPage';
// import FollowingPage from './components/FollowingPage';
// import PostCommentsPage from './screen/dashboard/PostCommentsPage';
// import SettingsPage from './screen/dashboard/SettingsPage';
// import PostDetailPage from './components/PostDetailPage';
// import SuggestedUsersPage from './components/SuggestedUsersPage';
// import FeedbackPage from './components/settings/FeedbackPage';
// import { ToastContainer } from 'react-toastify';
// import './App.css';

// /**
//  * Derives the currently-open conversationId from the URL.
//  *
//  * Matches both route shapes:
//  *   /messages/:userId  → returns userId
//  *   /chat              → returns null  (no specific conversation open)
//  *   anything else      → returns null  (user is not on the chat page)
//  *
//  * Passing this to useSignalRChat tells the SignalR handler NOT to increment
//  * the unread count for the conversation the user is actively reading.
//  * When null, every incoming message increments unread count — correct behaviour
//  * for every page other than an open conversation.
//  */
// function useActiveChatId() {
//   const { pathname } = useLocation();
//   const match = pathname.match(/^\/messages\/([^/]+)/);
//   return match ? match[1] : null;
// }

// function App() {
//   const currentUserId =
//     useSelector((state) => state.auth.userId) ?? localStorage.getItem('userId');
//   const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

//   // ── Apply saved theme ───────────────────────────────────────────────────────
//   useEffect(() => {
//     const savedTheme = localStorage.getItem('theme');
//     if (savedTheme) {
//       document.documentElement.setAttribute('data-theme', savedTheme);
//     }
//   }, []);

//   // ── Establish SignalR connection when authenticated ─────────────────────────
//   //
//   // isAuthenticated and currentUserId are both in the dep array so this
//   // reconnects correctly after login and disconnects on logout.
//   //
//   // useSignalRChat (below) also calls connect() internally, so this effect is
//   // a belt-and-suspenders early connect — it does NOT duplicate the handler
//   // registration (that lives entirely inside useSignalRChat).
//   useEffect(() => {
//     if (!isAuthenticated || !currentUserId) return;

//     const token = localStorage.getItem('authToken');
//     if (!token) return;

//     if (!signalRService.isConnected()) {
//       signalRService.connect(token).catch((err) => {
//         console.error('SignalR connection failed:', err);
//       });
//     }

//     // Disconnect when the user logs out.
//     // The cleanup captures `isAuthenticated` correctly because it re-runs
//     // whenever `isAuthenticated` changes (it's in the dep array).
//     return () => {
//       if (signalRService.isConnected()) {
//         signalRService.disconnect();
//       }
//     };
//   }, [isAuthenticated, currentUserId]);

//   // ── Derive which conversation (if any) is currently open ───────────────────
//   // Used to suppress unread-count increments for the active conversation.
//   const activeChatId = useActiveChatId();

//   // ── Global real-time message handler ───────────────────────────────────────
//   //
//   // THIS is what drives unread counts, last-message previews, and message-cache
//   // updates on every page — not just when ChatPage is mounted.
//   //
//   // activeChatId MUST be passed so the handler knows which conversation the
//   // user is currently reading. Without it, the unread count increments even
//   // while the user is looking at the conversation.
//   useSignalRChat(currentUserId, activeChatId);

//   // ── Global notification handler ─────────────────────────────────────────────
//   useSignalRNotifications(currentUserId);

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 99999 }} />

//       <Routes>
//         {/* ── Public routes ── */}
//         <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
//       <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
//         <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
//         <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />

//         {/* ── Protected routes ── */}
//         <Route
//           path="/user-details"
//           element={
//             <ProtectedRoute requireProfileComplete={false}>
//               <UserDetailsForm />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/home"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <HomePage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/profile"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <ProfilePage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/profile/:userId"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <ProfilePage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/profile/:userId/followers"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <FollowersPage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/profile/:userId/following"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <FollowingPage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/post/:postId/comments"
//           element={<PostCommentsPage />}
//         />

// <Route path="/settings/feedback" element={<FeedbackPage />} />

//         <Route
//           path="/post/:id"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <PostDetailPage />
//             </ProtectedRoute>
//           }
//         />

//         {/* ── Chat routes ── */}
//         <Route
//           path="/chat"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <ChatPage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/messages/:userId"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <ChatPage />
//             </ProtectedRoute>
//           }
//         />

//         {/* ── Settings ── */}
//         <Route
//           path="/settings"
//           element={
//             <ProtectedRoute requireProfileComplete={true}>
//               <SettingsPage />
//             </ProtectedRoute>
//           }
//         />

//         {/* ── Misc ── */}
//         <Route path="/suggested-users" element={<SuggestedUsersPage />} />

//         {/* ── Fallback ── */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </>
//   );
// }

// export default App;

// src/App.js
// ─── ADD 2 THINGS to your existing App.js ────────────────────────────────────
//
//  1. Import LandingPage at the top:
//       import LandingPage from './screen/LandingPage/LandingPage';
//
//  2. Change the "/" route from:
//       <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
//     to:
//       <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
//
//  3. Keep "/login" pointing to Login:
//       <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
//
//  Everything else in App.js stays EXACTLY the same.
// ─────────────────────────────────────────────────────────────────────────────
// src/App.js
// ─── ADD 2 THINGS to your existing App.js ────────────────────────────────────
//
//  1. Import LandingPage at the top:
//       import LandingPage from './screen/LandingPage/LandingPage';
//
//  2. Change the "/" route from:
//       <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
//     to:
//       <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
//
//  3. Keep "/login" pointing to Login:
//       <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
//
//  Everything else in App.js stays EXACTLY the same.
// ─────────────────────────────────────────────────────────────────────────────


import NotificationsPage from './components/notifications/NotificationsPage';
 
import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AIFloater from './components/AIFloater';
import LandingPage from './screen/LandingPage/LandingPage';
import FounderPage from './screen/LandingPage/LandingFounder';
import EntrepreneurPage from './screen/LandingPage/LandingEntrepreneur';
import MentorPage from './screen/LandingPage/LandingMentor';
import InvestorsPage from './screen/LandingPage/LandingInvestors';
import FreelancerPage from './screen/LandingPage/LandingFreelancer';
import BPPage from './screen/LandingPage/LandingBusinessProfessional';
import RookiePage from './screen/LandingPage/LandingRookie';
import CompanyPage from './screen/LandingPage/LandingCompany';
import Login from './screen/AuthScreen/Login';
import Register from './screen/AuthScreen/Register';
import ForgotPassword from './screen/AuthScreen/ForgotPassword';
import ResetPassword from './screen/AuthScreen/ResetPassword';
import UserDetailsForm from './screen/UserDetailScreen/UserDetailsForm';
import HomePage from './screen/dashboard/HomePage';
import ProfilePage from './screen/dashboard/ProfilePage';
import ChatPage from './screen/dashboard/ChatPage';
import PublicRoute from './components/auth/PublicRoute';
import ProtectedRoute from './components/auth/ProtectedRoute';
import signalRService from './services/signalrService';
import { useSignalRChat } from './store/api/chatApi';
import { useSignalRNotifications } from './store/api/notificationApi';
import FollowersPage from './components/FollowersPage';
import FollowingPage from './components/FollowingPage';
import PostCommentsPage from './screen/dashboard/PostCommentsPage';
import SettingsPage from './screen/dashboard/SettingsPage';
import PostDetailPage from './components/PostDetailPage';
import SuggestedUsersPage from './components/SuggestedUsersPage';
import FeedbackPage from './components/settings/FeedbackPage';
import { ToastContainer } from 'react-toastify';
import './App.css';
import NewsPage from './screen/dashboard/NewsPage';
import PrivacyPolicyPage from "./screen/dashboard/PrivacyPolicyPage";
import TermsPage from "./screen/dashboard/TermsPage";
import EntrepreneurLandingPage from './screen/LandingPage/LandingEntrepreneur';
function useActiveChatId() {
  const { pathname } = useLocation();
  const match = pathname.match(/^\/messages\/([^/]+)/);
  if (match) return match[1];
  if (pathname.startsWith('/chat')) {
    return sessionStorage.getItem('activeChatId') || null;
  }
  return null;
}
 
function App() {
  const currentUserId =
    useSelector((state) => state.auth.userId) ?? localStorage.getItem('userId');
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
 
  useEffect(() => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      document.documentElement.setAttribute('data-theme', saved);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }
  }, []);
 
  useEffect(() => {
    if (!isAuthenticated || !currentUserId) return;
    const token = localStorage.getItem('authToken');
    if (!token) return;
    if (!signalRService.isConnected()) {
      signalRService.connect(token).catch(console.error);
    }
    return () => {
      if (signalRService.isConnected()) signalRService.disconnect();
    };
  }, [isAuthenticated, currentUserId]);
 
  const activeChatId = useActiveChatId();
  useSignalRChat(currentUserId, activeChatId);
  useSignalRNotifications(currentUserId);
 
  return (
   <>
  <ToastContainer
    position="top-right"
    autoClose={3000}
    style={{ zIndex: 99999 }}
  />
 
  <Routes>
        {/* ── Public routes ── */}
        <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
          {/* ← CHANGED */}
          <Route path="/founder" element={<PublicRoute><FounderPage /></PublicRoute>} /> 
          <Route path="/entrepreneur" element={<PublicRoute><EntrepreneurPage /></PublicRoute>} /> 
          <Route path="/freelancer" element={<PublicRoute><FreelancerPage /></PublicRoute>} /> 
          <Route path="/mentor" element={<PublicRoute><MentorPage /></PublicRoute>} /> 
          <Route path="/businessprofessional" element={<PublicRoute><BPPage /></PublicRoute>} /> 
          <Route path="/rookie" element={<PublicRoute><RookiePage /></PublicRoute>} /> 
          <Route path="/investor" element={<PublicRoute><InvestorsPage /></PublicRoute>} /> 
          <Route path="/company" element={<PublicRoute><CompanyPage /></PublicRoute>} /> 
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />   {/* ← NEW */}
        <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
                 <Route
path="/privacy-policy"
element={<PrivacyPolicyPage />}
/>
 
<Route
path="/terms-and-conditions"
element={<TermsPage />}
/>
        {/* ── Protected routes ── */}
        <Route path="/user-details" element={<ProtectedRoute requireProfileComplete={false}><UserDetailsForm /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute requireProfileComplete={true}><NotificationsPage /></ProtectedRoute>} />
        <Route path="/home" element={<ProtectedRoute requireProfileComplete={true}><HomePage /></ProtectedRoute>} />
        <Route path="/news" element={<ProtectedRoute requireProfileComplete={true}><NewsPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute requireProfileComplete={true}><ProfilePage /></ProtectedRoute>} />
        <Route path="/profile/:userId" element={<ProtectedRoute requireProfileComplete={true}><ProfilePage /></ProtectedRoute>} />
        <Route path="/profile/:userId/followers" element={<ProtectedRoute requireProfileComplete={true}><FollowersPage /></ProtectedRoute>} />
        <Route path="/profile/:userId/following" element={<ProtectedRoute requireProfileComplete={true}><FollowingPage /></ProtectedRoute>} />
        <Route path="/post/:postId/comments" element={<PostCommentsPage />} />
        <Route path="/settings/feedback" element={<FeedbackPage />} />
        <Route path="/post/:id" element={<PostDetailPage />} />
        <Route path="/chat" element={<ProtectedRoute requireProfileComplete={true}><ChatPage /></ProtectedRoute>} />
        <Route path="/messages/:userId" element={<ProtectedRoute requireProfileComplete={true}><ChatPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute requireProfileComplete={true}><SettingsPage /></ProtectedRoute>} />
        <Route path="/suggested-users" element={<SuggestedUsersPage />} />
       <Route path="*" element={<Navigate to="/" replace />} />
</Routes>
{isAuthenticated && <AIFloater />}
</>
  );
}
 
export default App;